import './liveTrackContent.css';
import DropDown from "../../../shared/drop-down/dropDown";
import LiveTrackVehicles from "../liveTrackVehicles/liveTrackVehicles";
import ReactMap from "../../../shared/map/map";
import LiveTrackMap from "../liveTrackMap/liveTrackMap";
import PopupModel from "../../../shared/popupModel/popupModel";
import {useState} from "react";

const LiveTrackContent = ({vehicles = [], handleVehicleSelect = (vehicle) => {}, vehiclePos}) => {



    return (
        <div className={'flex align-top live-track-content'}>
            <div className={'vehicle-trips-sec'}>
                <div className="">
                    <div className="section-title">Vehicles</div>
                    <div className="margin-b-20 round-corner-8">
                        <DropDown classes={'trans-drop-down'} list={['Active', 'Inactive']} placeholder={'Filter'}/>
                    </div>
                    <div className="search-box margin-b-20 round-corner-8">
                        <input type="text" placeholder={'Search'}/>
                    </div>
                    <LiveTrackVehicles vehicles={vehicles} handleVehicleSelect={handleVehicleSelect}/>
                </div>
            </div>

            <div className={'map-sec'}>
                <div className="section-title margin-b-20">Map</div>
                <div className={'live-track-map'}>
                    {<LiveTrackMap vehiclePos={vehiclePos}/>}
                </div>
            </div>


        </div>
    )
}


export default LiveTrackContent;
